// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { Text } from '@plesk/ui-library';
import { Locale } from 'jsw';
import { NotificationPropType } from './lib/PropTypes';

const Translate = Locale.getTranslate('components.notification-center');

const NotificationDate = ({ notification, ...props }) => {
    const { displayDate } = notification;
    const today = new Date();
    const date = new Date(displayDate);
    const isToday =
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear();

    return isToday ? (
        <Translate
            component={Text}
            nowrap
            content="timeFormat"
            params={{
                hours: `0${date.getHours()}`.slice(-2),
                minutes: `0${date.getMinutes()}`.slice(-2),
            }}
            {...props}
        />
    ) : (
        <Translate
            component={Text}
            nowrap
            content="dateFormat"
            params={{
                day: date.getDate(),
                month: (<Translate content={`month${date.getMonth()}`} />),
            }}
            {...props}
        />
    );
};

NotificationDate.propTypes = {
    notification: NotificationPropType.isRequired,
};

export default NotificationDate;
